import PropTypes from 'prop-types';
import React, { useCallback, useEffect, memo } from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import { updateStatusCode, saveStatusCodes, getBuyers } from '../../actions/company/companyTarget';
import { reloadEvents } from '../../actions/company/companyEvents';
import { unwrap } from '../../utils/ChangeSpy';
import { usePopupContext } from '../../contexts/PopupContext';

const StatusCodePopupContainer = props => {
  const { closePopup } = usePopupContext();
  const { popup, statusUpdate, statuses, buyer, updateStatusCode, saveStatusCodes, reloadEvents, getBuyers } = props;

  useEffect(() => {
    const start = popup.getIn(['props', 'start']);
    const end = popup.getIn(['props', 'end']);

    updateStatusCode({
      field: 'statusUpdate',
      value: Map({ mid: '4.60', start, end, waiting: false }),
    });
  }, []);

  const getStatusSummary = useCallback(
    value => {
      const key = statuses.findKey(s => s.get('value') === value);

      if (key !== undefined && key !== null) {
        return statuses.getIn([key, 'summary']);
      }

      return '';
    },
    [statuses],
  );

  const onChange = useCallback(
    event => {
      updateStatusCode({
        field: 'statusUpdate.mid',
        value: event.target.value,
      });
    },
    [updateStatusCode],
  );

  const onSave = useCallback(() => {
    const companyId = popup.getIn(['props', 'companyId']);
    const buyerId = popup.getIn(['props', 'buyerId']);
    const start = statusUpdate.get('mid');
    const end = statusUpdate.get('end');

    updateStatusCode({
      field: 'statusUpdate.waiting',
      value: true,
    });

    saveStatusCodes({
      companyId,
      buyerId,
      start: {
        bsnHarvco: getStatusSummary(start),
        currentStatus: start,
      },
      end: {
        bsnHarvco: getStatusSummary(end),
        currentStatus: end,
      },
      afterSuccess: () => {
        updateStatusCode({
          field: 'statusUpdate.waiting',
          value: false,
        });
        reloadEvents({ entityId: companyId });
        getBuyers({ companyId, afterSuccess: () => {} });
        closePopup();
      },
    });
  }, [popup, statusUpdate, updateStatusCode, saveStatusCodes, getStatusSummary, reloadEvents, getBuyers, closePopup]);

  return (
    <Popups.StatusCodePopup
      buyer={buyer}
      onChange={onChange}
      onSave={onSave}
      statuses={statuses}
      statusUpdate={statusUpdate}
    />
  );
};

StatusCodePopupContainer.propTypes = {
  buyer: PropTypes.string,
  getBuyers: PropTypes.func.isRequired,
  popup: PropTypes.object.isRequired,
  reloadEvents: PropTypes.func.isRequired,
  saveStatusCodes: PropTypes.func.isRequired,
  statuses: PropTypes.object.isRequired,
  statusUpdate: PropTypes.object,
  updateStatusCode: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  const buyers = state.targetCompany.target.get('buyers');
  const key = buyers.findKey(b => unwrap(b.get('activeBuyer')));
  let buyer = '';

  if (key !== null && key !== undefined) {
    buyer = unwrap(buyers.getIn([key, 'dsplBuyerLegalName'], ''));
  }

  return {
    ...props,
    statuses: state.targetCompany.target.get('statuses'),
    statusUpdate: state.targetCompany.target.get('statusUpdate'),
    buyer,
  };
};

export default connect(
  mapStateToProps,
  {
    updateStatusCode,
    saveStatusCodes,
    reloadEvents,
    getBuyers,
  },
  mergeProps,
  connectOptions,
)(memo(StatusCodePopupContainer));
